import * as React from "react";
import {useCallback, useEffect} from "react";
import {Dialog, DialogContent, DialogFooter, DialogTitle, PushButton} from "@variocube/cube-ui";
import {style, stylesheet} from "typestyle";
import {useMessage, useSetMessage} from './DialogMessageProvider';
import {useCubeCarrier} from "./CarrierProvider";
import {useLocalization} from "../i18n";

export function MessageDialog() {
    const {t} = useLocalization();
    const message = useMessage();
    const setMessage = useSetMessage();
    const cubeCarrier = useCubeCarrier();

    const handleClose = useCallback(() => {
        if (!message?.disableAutoClose) {
            setMessage(undefined);
        }
    }, [message]);

    useEffect(() => {
        if(message && !message.disableAutoClose) {
            const autoCloseTimer = setTimeout(() => {
                handleClose();
            }, cubeCarrier?.messageDialogConfiguration?.autoCloseTimer || 20000);
            return () => {
                clearTimeout(autoCloseTimer);
            };
        }
    }, [message, handleClose]);

    return (
        <Dialog open={message != undefined} onBackdropClick={handleClose}>
            <div className={style({ width: "45em"})}>
                <DialogTitle>
                    {message?.title}
                </DialogTitle>
                <DialogContent>
                    {message?.message}
                </DialogContent>
                <DialogFooter>
                    <div className={styles.dialogFooter}>
                        {
                            !cubeCarrier?.messageDialogConfiguration?.hideCloseButton && (
                                <PushButton onClick={handleClose}>{t("Close")}</PushButton>
                            )
                        }
                        {message?.cancel && (<PushButton onClick={message?.cancel}>{t("Cancel")}</PushButton>)}
                        {message?.confirm && (<PushButton primary onClick={message?.confirm}>{t("Confirm")}</PushButton>)}
                    </div>
                </DialogFooter>
            </div>
        </Dialog>
    );
}

const styles = stylesheet({
    dialogFooter: {
        display: 'flex',
        justifyContent: 'space-evenly',
    },
});